<script setup lang="ts">
import VueApexCharts from 'vue3-apexcharts'
import {storeToRefs} from "pinia";
import {DashboardRangeStore} from "@/scripts/store/dashboard_range.store";
import {useAnalytics} from "@/scripts/store/analytics";
import VLoader from "@/scripts/components/app/common/VLoader.vue";
import {ref} from "vue";
import {useAccount} from "@/scripts/store/account";

export interface Props {
    codeIdentifier: String
}

const props = defineProps<Props>();
const isLoading = ref(false)

const dashboardRange = DashboardRangeStore()
const analytics = useAnalytics();

const {currentRange} = storeToRefs(dashboardRange)

const subscription = useAccount()
const {account} = storeToRefs(subscription);
const {deviceTrendsData} = storeToRefs(analytics);
const isAvailableForCurrentPlan = account.value.currentPlan.label !== 'free'

const series = ref([])
const chartOptions = ref({
    chart: {
        type: "donut",
        zoom: {
            enabled: !0
        }
    },
    noData: {
        text: "No data",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0
    },
    labels: [],
    dataLabels: {
        enabled: !1
    },
    stroke: {
        curve: "smooth"
    },
    legend: {
        position: "bottom",
        horizontalAlign: "left"
    }
})

const refreshSeries = async () => {
    if (!isAvailableForCurrentPlan) {
        return
    }

    isLoading.value = true
    await analytics.loadDeviceTrends(currentRange.value.from, currentRange.value.to, props.codeIdentifier)

    const labels = []
    series.value = []

    for (const item of deviceTrendsData.value) {
        labels.push(item.title)
        series.value.push(item.count)
    }

    chartOptions.value.labels = labels
    isLoading.value = false
}

refreshSeries()
dashboardRange.$subscribe((mutation, state) => {
    refreshSeries()
})

</script>

<template>
  <div class="bg-white overflow-hidden shadow sm:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
      <div>
        Топ устройств
      </div>
        <div v-if="isAvailableForCurrentPlan">
            <div v-if="!isLoading" class="mt-2">
                <apexchart ref="apexChart" type="pie" height="350" :options="chartOptions" :series="series"></apexchart>
            </div>
            <div v-else>
                <v-loader class="mt-2"></v-loader>
            </div>
        </div>
        <div class="mt-8" v-else>
                <span
                    class="cursor-pointer inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                    <a href="/billing">
                        недоступно на free плане
                    </a>
                </span>
        </div>
    </div>
  </div>
</template>


